import React from 'react';
import { Modal, Box, SpaceBetween, Button, FormField, Select } from '@amzn/awsui-components-core';

interface CreateMeetingModalProps {
  visible: boolean;
  onDismiss: () => void;
  onCreate: () => void;
  meetingFormContent?: React.ReactNode;
  timeSlotOptions: Array<{ label: string; value: string }>;
  selectedSlotId: string | null;
  onSelectedSlotChange: (slotId: string | null) => void;
}

export const CreateMeetingModal: React.FC<CreateMeetingModalProps> = ({
  visible,
  onDismiss,
  onCreate,
  meetingFormContent,
  timeSlotOptions,
  selectedSlotId,
  onSelectedSlotChange
}) => (
  <Modal
    visible={visible}
    onDismiss={onDismiss}
    header="Create Meeting"
    size="xx-large"
    footer={
      <Box float="right">
        <SpaceBetween direction="horizontal" size="xs">
          <Button variant="link" onClick={onDismiss}>
            Cancel
          </Button>
          <span className="blue-button">
            <Button variant="primary" onClick={onCreate} disabled={!selectedSlotId}>
              Create
            </Button>
          </span>
        </SpaceBetween>
      </Box>
    }
  >
    <SpaceBetween direction="vertical" size="s">
      <div className="create-meeting-modal-form">{meetingFormContent}</div>

      <div style={{ padding: '0 24px' }}>
        <FormField label="Meeting Time" description="Select the confirmed meeting time from the proposed options.">
          <Select
            selectedOption={timeSlotOptions.find((o) => o.value === selectedSlotId) ?? null}
            onChange={({ detail }) => {
              onSelectedSlotChange(detail.selectedOption.value ?? null);
            }}
            options={timeSlotOptions}
            placeholder="Select a time slot..."
          />
        </FormField>
      </div>
    </SpaceBetween>
  </Modal>
);
